export enum ServerExceptionEnum {
    SUCCESS = 'SUCCESS',
    QUOTE_NOT_FOUND_EXCEPTION = 'QUOTE_NOT_FOUND_EXCEPTION',
    SHIPMENT_INVALID_STATE_FOR_SUBMIT = 'SHIPMENT_INVALID_STATE_FOR_SUBMIT'
}
